import * as React from 'react';
import { useReducer } from 'react';
import setUrlParams from '../utils/setUrlParams';

const actions = {
	SET_TAX_OPTIONS: 'SET_TAX_OPTIONS',
	SELECT_TAX_TERM: 'SELECT_TAX_TERM',
	CLEAR_FILTERS: 'CLEAR_FILTERS',
	SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
};

const reducer = (state, action) => {
	switch (action.type) {
		case actions.SET_TAX_OPTIONS: {
			return {
				...state,
				tax: action.payload,
			};
		}
		case actions.SET_SEARCH_QUERY: {
			const hadQuery = state.hadQuery ? state.hadQuery : !!action.payload.length;
			const newState = {
				...state,
				searchQuery: action.payload,
				hadQuery,
			};

			setUrlParams(newState);

			return newState;
		}

		case actions.SELECT_TAX_TERM: {
			const selectedTax = { ...state.selectedTax };
			if (action.payload.term !== '') {
				selectedTax[action.payload.tax] = action.payload.term;
			} else if ('undefined' !== typeof selectedTax[action.payload.tax]) {
				delete selectedTax[action.payload.tax];
			}

			return {
				...state,
				selectedTax,
			};
		}

		case actions.CLEAR_FILTERS: {
			return {
				...state,
				selectedTax: state.initSelectedTax,
				searchQuery: '',
			};
		}

		default: {
			return state;
		}
	}
};

const FiltersContext = React.createContext();

const FiltersProvider = ({ children }) => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const initialState = {
		searchQuery: urlParams.get('s'),
		tax: {
			postType: [
				{
					label: 'Products',
					value: 'sek_product',
				},
				{
					label: 'Pages',
					value: 'page',
				},
				{
					label: 'News',
					value: 'post',
				},
				{
					label: 'Videos',
					value: 'video',
				},
			],
		},
		selectedTax: {},
		initSelectedTax: {},
		hadQuery: urlParams.get('s').length,
	};

	const [state, dispatch] = useReducer(reducer, initialState);

	const value = {
		tax: state.tax,
		selectedTax: state.selectedTax,
		searchQuery: state.searchQuery,
		hadQuery: state.hadQuery,
		selectTaxTerm: (tax, term) => {
			dispatch({ type: actions.SELECT_TAX_TERM, payload: { tax, term } });
		},
		setSearchQuery: (query) => {
			dispatch({ type: actions.SET_SEARCH_QUERY, payload: query });
		},
		clearFilters: () => {
			dispatch({ type: actions.CLEAR_FILTERS });
		},
	};

	return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};

const useFiltersContext = () => React.useContext(FiltersContext);

export { FiltersProvider, useFiltersContext };
